import styled from 'styled-components'

export const RankmiTableWrapper = styled.div`
  .ant-table-wrapper {
    margin-top: -9px;
  }
  .rankmiTable-addButton {
    width: 115px;
  }
`

export const Options = styled.div`
  button {
    background-color: #e7f3fe !important;
    color: #0085ff !important;
    border-radius: 8px;
    padding: 0 8px;
    border: none;
    height: 32px;
    font-weight: 700;
    svg {
      transition: 200ms;
    }
    &:hover {
      svg {
        opacity: 0.7;
      }
    }
  }
  > button {
    background-color: #f0f0f0 !important;
    color: #4c4c4c !important;
    margin-left: 8px;
  }
`

interface IProfileProps {
  color: string
}

export const Profile = styled.span<IProfileProps>`
  font-size: 12px;
  border-radius: 8px;
  padding: 4px;
  background-color: ${(props) => props.color}29;
  border: 1px solid ${(props) => props.color};
`
